import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getOrderGeneratorsFieldsWorksExecutorsBrigades(companyId, generatorId, executorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].getOrderGeneratorsFieldsWorksExecutorsBrigades,
		{
			urlParams: {
				companyId,
				generatorId,
				executorId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksExecutorsBrigade(companyId, generatorId, executorId, brigadeId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].getOrderGeneratorsFieldsWorksExecutorsBrigade,
		{
			urlParams: {
				companyId,
        generatorId,
				executorId,
				brigadeId,
			},
		}
	)
}

function createOrderGeneratorsFieldsWorksExecutorsBrigade(companyId, generatorId, executorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].createOrderGeneratorsFieldsWorksExecutorsBrigade,
		{
			urlParams: {
				companyId,
        generatorId,
				executorId,
			},
			...payload,
		}
	)
}


function putOrderGeneratorsFieldsWorksExecutorsBrigade(companyId, generatorId, executorId, brigadeId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].putOrderGeneratorsFieldsWorksExecutorsBrigade,
		{
			urlParams: {
				companyId,
        generatorId,
				executorId,
				brigadeId,
			},
			...payload,
		}
	)
}

function patchOrderGeneratorsFieldsWorksExecutorsBrigade(companyId, generatorId, executorId, brigadeId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].patchOrderGeneratorsFieldsWorksExecutorsBrigade,
		{
			urlParams: {
				companyId,
        generatorId,
				executorId,
				brigadeId,
			},
			...payload,
		}
	)
}

function deleteOrderGeneratorsFieldsWorksExecutorsBrigade(companyId, generatorId, executorId, brigadeId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].deleteOrderGeneratorsFieldsWorksExecutorsBrigade,
		{
			urlParams: {
				companyId,
        generatorId,
				executorId,
				brigadeId,
			},
		}
	)
}

export default {
	getOrderGeneratorsFieldsWorksExecutorsBrigades,
	getOrderGeneratorsFieldsWorksExecutorsBrigade,
	createOrderGeneratorsFieldsWorksExecutorsBrigade,
	putOrderGeneratorsFieldsWorksExecutorsBrigade,
	patchOrderGeneratorsFieldsWorksExecutorsBrigade,
	deleteOrderGeneratorsFieldsWorksExecutorsBrigade,
}

